// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1ML-G{margin-bottom:.25rem}._3s1uR{margin-bottom:2rem}@media(max-width:767px){.cNLmd{position:absolute;bottom:0;width:100%}}._1mABm{cursor:pointer}@media(min-width:768px){._1mABm{display:none}}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"subTitle": "_1ML-G",
	"score": "_3s1uR",
	"submitButton": "cNLmd",
	"back": "_1mABm"
};
module.exports = exports;
